import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {Row, Col} from 'reactstrap';
import MotsPorSindicatoStore from "../stores/MotsPorSindicatoStore";
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import {MensagemErro} from "../../comum/components/MensagemErro";
import DataWrapper from "../../principal/containers/DataWrapper";
import {Filtro} from "../../comum/components/Filtro";

const FILTROS = ["EMPRESA", "SINDICATO"];
const VALIDACOES = ["EMPRESA_OBRIGATORIA", "SINDICATO_OBRIGATORIO"];

@inject("store")
@DataWrapper
@observer
export class MotsPorSindicato extends Component {
    constructor(props) {
        super(props);
        this.controller = new MotsPorSindicatoStore();
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Mots por sindicato");
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="content-panel">
                    <LoadingBlockFields carregando={this.controller.carregando}>
                        <Filtro history={this.props.history}
                                controller={this.controller}
                                location={this.props.location}
                                fields={FILTROS}
                                validations={VALIDACOES}
                                onExportExcel={(filtro) => this.controller.onExportExcel(filtro)} />
                    </LoadingBlockFields>
                    {this.controller.erro &&
                        <MensagemErro>
                            {this.controller.erro}
                        </MensagemErro>
                    }
                </div>
            </div>
        )
    }
}
